import React from 'react';
import { useSuspenseQuery } from '@apollo/client';
import { Event } from '../../../../../model/event';
import { t } from '../../../../../locales/translate';
import { Card } from '../../../../../components/Card/Card';
import { graphql } from '../../../../../generated';
import { Icon } from '../../../../../components/Icon/Icon';
import { KeyValueTable } from '../../../../../components/KeyValueTable/KeyValueTable';
import { formatDateTime } from '../../../../../util/formatters';
import { useModalPresenter } from '../../../../../components/Modal/PresentedModal';
import { Text } from '../../../../../components/text/text';
import { Stack } from '../../../../../components/Stack/Stack';
import { AutomationForm } from './automation_form';
import { withSuspendedCard } from '../../../../../util/suspense';

const EVENT_AUTOMATION = graphql(`
  query EventAutomation($id: ID!) {
    event(id: $id) {
      id
      automations {
        nodes {
          id
          operation
          executeAt
        }
      }
    }
  }
`);

function DelayedOnlineTicketsContent({ event }: { event: Event }): JSX.Element {
  const { data } = useSuspenseQuery(EVENT_AUTOMATION, { variables: { id: event.id } });
  const automation = data.event.automations?.nodes.find((node) => node.operation === 'SEND_DELAYED_TICKETS');

  if (!automation) {
    return (
      <Stack>
        <Text type={'automation-menu-item'}>{t.page.event.details.ticketDelay.noAutomation}</Text>
      </Stack>
    );
  }

  const keyValueTableItems = [
    {
      key: t.page.event.details.ticketDelay.ticketsWillBeSentAt,
      value: formatDateTime(automation.executeAt),
    },
  ];

  return <KeyValueTable items={keyValueTableItems} gap="16" />;
}

function DelayedOnlineTickets$({ event }: { event: Event }): JSX.Element {
  const modal = useModalPresenter();

  return (
    <section>
      <Card
        title={t.page.event.details.ticketDelay.cardTitle}
        actions={<Icon name="edit" onClick={() => modal.present(AutomationForm, { id: event.id })} />}
      >
        <DelayedOnlineTicketsContent event={event} />
      </Card>
    </section>
  );
}

export const DelayedOnlineTickets = withSuspendedCard(DelayedOnlineTickets$, {
  loadingTitle: t.page.event.details.ticketDelay.cardTitle,
});
